import { render, staticRenderFns } from "./PersonVisitors.vue?vue&type=template&id=35c2b202"
import script from "./PersonVisitors.vue?vue&type=script&lang=js"
export * from "./PersonVisitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports